import { render, staticRenderFns } from "./LoadCustomerWalletModal.vue?vue&type=template&id=16189e10"
import script from "./LoadCustomerWalletModal.vue?vue&type=script&lang=js"
export * from "./LoadCustomerWalletModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports